<template>
  <div class="login default-layout">
    <network-status v-if="$platform === 'electron'" />
    <navbar-login />
    <nuxt />
    <GlobalLoader />
  </div>
</template>

<script>
import NavbarLogin from '~/components/navbar-login.vue'
import NetworkStatus from '~/components/networkStatus'
import GlobalLoader from '~/components/GlobalLoader'

export default {
  components: {
    NavbarLogin,
    NetworkStatus,
    GlobalLoader,
  },
}
</script>

<style lang="scss">
.login {
  min-height: 100vh;
}
</style>
